import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type SliderProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/**
 * Styled NATIVE range input, brand-accented. Kept native for the platform
 * thumb/track and its built-in keyboard + AT semantics. The taller
 * coarse-pointer track keeps the thumb draggable on touch. Callers provide
 * the accessible name.
 *
 * dnd-kit note: when a Slider sits inside a sortable row, keep the drag
 * listeners on an explicit handle (setActivatorNodeRef) — a row-level
 * PointerSensor (distance: 6) swallows slider drags.
 */
export const Slider = forwardRef<HTMLInputElement, SliderProps>(function Slider(
  { className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type="range"
      className={cn('cursor-pointer accent-brand pointer-coarse:h-11', className)}
      {...rest}
    />
  );
});
